import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import Button from 'components/modules/button/Button';
import Modal from 'components/modules/modal/Modal';
import { DetailItem, RoomInfoItems } from 'constant';
import { updateRoom } from 'services/api-service/center';

interface ModalMemoProps {
  items: DetailItem;
  onClose: () => void;
}

const ModalDetail = ({ items, onClose }: ModalMemoProps) => {
  const [isShow, setShow] = useState(true);
  const [detail, setDetail] = useState<DetailItem>(items);

  const _Close = () => {
    setShow(false);
    onClose();
  };

  const _Save = async () => {
    try {
      const response: any = await updateRoom(
        detail.roomId,
        detail.lat.toString(),
        detail.lng.toString(),
        detail.accDate,
        detail.accTime,
        detail.accLoc,
        detail.accDtl,
        detail.prcRslt,
        detail.dLoc,
        detail.wCond,
        detail.accType,
        detail.dType,
        detail.dRoute,
        detail.mdn,
        detail.alimType
      );
      if (response.result === 'success') {
        toast('사고정보가 수정되었습니다.', { type: 'success' });
      }
    } catch (error) {
      console.log('_Save', error);
    }
    setShow(false);
    onClose();
  };

  const onChangeSelect = (key: string, e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setDetail((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    if (detail !== undefined) {
      setShow(detail.isOpen);
    }
  }, [detail]);

  return (
    <Modal isOpen={isShow} onClose={() => _Close()}>
      <ModalTemplate>
        <HeaderWrap>
          <HeaderTitle>{'해양사고 처리결과'}</HeaderTitle>
        </HeaderWrap>

        <ContentsWrap>
          <HorizontalWrap>
            <SubTitleWrap>{detail.belong}&nbsp;담당자</SubTitleWrap>
            <TextWrap>{detail.userName}</TextWrap>
          </HorizontalWrap>
          <HorizontalWrap>
            <SubTitleWrap>해양사고 발생일시</SubTitleWrap>
            <TextWrap>
              {detail.accDate} {detail.accTime}
            </TextWrap>
          </HorizontalWrap>
          <HorizontalWrap>
            <SubTitleWrap>해양사고 접수일시</SubTitleWrap>
            <TextWrap>{detail.saveTime}</TextWrap>
          </HorizontalWrap>
          <HorizontalWrap>
            <SubTitleWrap>해양사고 위치</SubTitleWrap>
            <TextWrap>
              {detail.lat.toFixed(6)} / {detail.lng.toFixed(6)}
            </TextWrap>
          </HorizontalWrap>
          <HorizontalWrap>
            <SubTitleWrap>해양사고 내용</SubTitleWrap>
            <TextWrap>{detail.accDtl}</TextWrap>
          </HorizontalWrap>
          <HorizontalWrap>
            <SubTitleWrap>해양사고 처리결과</SubTitleWrap>
            <TextWrap>{detail.prcRslt}</TextWrap>
          </HorizontalWrap>
          <HorizontalWrap>
            <SubTitleWrap>해양사고 종료일시</SubTitleWrap>
            <TextWrap>{detail.expireTime}</TextWrap>
          </HorizontalWrap>
          {RoomInfoItems.map((item: any, index: number) => (
            <HorizontalWrap style={{ display: 'flex' }} key={index}>
              <SubTitleWrap>{item.title}</SubTitleWrap>
              <SelectWrap id={item.id} value={detail[item.id]} onChange={(e) => onChangeSelect(item.id, e)}>
                {item.options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </SelectWrap>
            </HorizontalWrap>
          ))}
          {detail.userInfos !== null && (
            <>
              {detail.userInfos.inviteTime !== '' && (
                <HorizontalWrap>
                  <SubTitleWrap>동원 요청</SubTitleWrap>
                  <TextWrap>{detail.userInfos.inviteTime}</TextWrap>
                </HorizontalWrap>
              )}
              {detail.userInfos.datas.length > 0 &&
                detail.userInfos.datas.map((user, index) => (
                  <HorizontalWrap key={index}>
                    <SubTitleWrap>
                      {user.center} &nbsp; {user.team} &nbsp; {user.name} &nbsp;
                      {user.memo === null ? '' : '(' + user.memo + ')'}
                    </SubTitleWrap>
                    <TextWrap>{user.connectTime}</TextWrap>
                  </HorizontalWrap>
                ))}
            </>
          )}
        </ContentsWrap>

        <FooterWrap>
          <Button title="수정" color="primary" onClick={() => _Save()} />
          <Button title="취소" color="secondary" onClick={() => _Close()} />
        </FooterWrap>
      </ModalTemplate>
    </Modal>
  );
};

const ModalTemplate = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100%);
  // height: calc(100% - 140px);
  flex-flow: column nowrap;
  background-color: #abc9df;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
`;
const HeaderWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: #11497e;
  // border-bottom: 2px solid #cccccc;
  border-radius: 10px 10px 0 0;
`;
const HeaderTitle = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  // justify-content: center;
  margin-left: 20px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
`;
const ContentsWrap = styled.div`
  padding: 20px;
  display: flex;
  flex-flow: column nowrap;
  @media (max-width: 319px) {
    padding: 0 10px;
  }
`;
const HorizontalWrap = styled.div`
  // padding: 15px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  // justify-content: center;
  border: 2px solid #ddd;
  & + & {
    border-top: none;
  }
`;
const SubTitleWrap = styled.div`
  width: 400px;
  position: relative;
  padding: 10px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  // border: 1px solid #ddd;
`;
const TextWrap = styled.div`
  width: calc(100% - 400px);
  position: relative;
  padding: 10px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  font-weight: 700;
  border-left: 2px solid #ddd;
  min-height: 45px;
  white-space: pre-line;
`;
const SelectWrap = styled.select`
  width: calc(100% - 400px);
  position: relative;
  padding: 10px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  font-weight: 700;
  border: none;
  border-left: 2px solid #ddd;
  min-height: 45px;
  white-space: pre-line;
  background-color: transparent;
`;
const FooterWrap = styled.div`
  padding: 20px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 5px;
    border-radius: 10px;
    min-height: 40px;
    max-width: 140px;
    cursor: pointer;
  }
`;

export default ModalDetail;
